<template>
  <div>
    <div :style="{height:imgWidth*0.262 + 'px',width:imgWidth}">
      <div class="imgTitle">电测 计量 检定 校验</div>
      <img style="width:100%;height:100%;" v-for="item in img" :key="item.id" :src="item.image" alt />
    </div>
    <div class="saleServe" :style="backgroundDiv">
      <div id="main">
        <div style="height:80px;width:100%;"></div>
        <div class="main_title">
          <div class="line"></div>
          <div style="color:#fff;font-size: 18px; font-family: Helvetica;font-weight: bold;">
            销售服务
            <span style="margin-left:40px;">SALES SERVICE</span>
            <router-link to="/">
              <img class="back_to_index" src="../../assets/images/back_to_index_white.png" alt />
            </router-link>
          </div>
        </div>

        <div class="rice_text" style="color:#fff;" v-html="service_data.service"></div>
      </div>
    </div>
    <!-- <div style="width:100%;height:20px;background-color:#eaeaea;"></div> -->

    <div id="main">
      <div class="saleFlow_left">
        <div class="main_title">
          <div class="line"></div>
          <div style="font-size: 18px; font-family: Helvetica;font-weight: bold;">销售流程</div>
        </div>

        <div class="saleFlow_left_img">
          <img
            v-for="(item,index) in service_data.images"
            :key="index"
            v-if="index == 0"
            :src="item"
            alt
          />
        </div>
      </div>

      <div class="servePromise">
        <div class="main_title">
          <div class="line"></div>
          <div style="font-size: 18px; font-family: Helvetica;font-weight: bold;">服务承诺</div>
        </div>

        <div v-html="service_data.promise"></div>
      </div>

      <img
        class="img_left"
        v-for="(item,index) in service_data.images"
        :key="index"
        v-if="index == 1"
        :src="item"
        alt
      />
      <img
        class="img_right"
        v-for="(item,index) in service_data.images"
        :key="index"
        v-if="index == 2"
        :src="item"
        alt
      />

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in imgs" :key="index">
            <div>
              <img class="img" :src="item.image" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
// import Swiper from "swiper";
// import "swiper/dist/css/swiper.css";
export default {
  data: function () {
    return {
      img: [],
      imgWidth: "",
      service_data: "",
      swiperOption: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 10,
        loop: true,
        speed: 600, //config参数同swiper4,与官网一致
      },
      backgroundDiv: {
        backgroundImage:
          "url(" + require("../../assets/images/saleServe_banner.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
      imgs: [],
    };
  },
  created: function () {
    // 获取头图数据
    this.$fetch("index/getAdList", { slot_id: 3 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.img = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
    this.imgWidth = document.body.clientWidth;
    setTimeout(function () {
      $(".imgTitle").css({ transform: "scale(1)", transition: "2s" });
    }, 1500);
    clearTimeout();
    this.$fetch("Salesservice/index").then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.service_data = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });

    this.$fetch("index/getBottomPic", { cate_id: 2 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.imgs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
  },
  updated: function () {
    var mySwiper = new Swiper(".swiper-container", {
      loop: true,
      autoplay: 3000,
      speed: 500,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
    });
  },
};
</script>
<style scoped>
.imgTitle {
  position: absolute;
  color: #fff;
  font-size: 54px;
  font-family: SimHei;
  font-weight: bold;
  top: 250px;
  left: 34%;
  z-index: 10;
  transform: scale(0);
}
.saleServe {
  width: 100%;
  height: 650px;
}
.main_title {
  width: 100%;
  height: 24px;
  margin: 40px 0;
  font-size: 20px;
  clear: both;
}
.line {
  background-color: #2569e6;
  width: 3px;
  height: 100%;
  float: left;
  margin-right: 20px;
  clear: both;
}
.saleFlow_left {
  display: inline-block;
  width: 580px;
  height: 900px;
}
.saleFlow_left .saleFlow_left_img {
  width: 100%;
  height: 810px;
}
.saleFlow_left .saleFlow_left_img img {
  width: 100%;
  height: 100%;
}
.servePromise {
  float: right;
  width: 580px;
}
.img_left {
  width: 580px;
  height: 800px;
  margin: 40px 30px 40px 0;
}
.img_right {
  width: 580px;
  height: 800px;
}

.swiper-slide div {
  padding: 20px 20px;
}
.swiper-slide div .img {
  height: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/saleServe/saleServe.vue